import React, { useState } from 'react';
import '../../css/sliderMB.css';
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const SliderMB = (props) => {

    const {
        listRespData,
    } = props;

    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [swiperIndexFirst, setSwiperIndexFirst] = useState(0);
    const [swiperInstanceFirst, setSwiperInstanceFirst] = useState(null);

    const handleSwiperSlideChangeFirst = (swiperFirst) => {
        setSwiperIndexFirst(swiperFirst.activeIndex);
    };

    const nextImageFirst = () => {
        if (swiperInstanceFirst !== null) {
            swiperInstanceFirst.slideNext();
        }
    };

    const prevImageFirst = () => {
        if (swiperInstanceFirst !== null) {
            swiperInstanceFirst.slidePrev();
        }
    };

  return (
    <div className={isTablet ? 'mainSecondViewContainerSliderMB' : 'mainSecondViewContainerSliderMBMobile'}>

        <Swiper
            onSlideChange={(swiperFirst) => handleSwiperSlideChangeFirst(swiperFirst)}
            onSwiper={(swiperFirst) => setSwiperInstanceFirst(swiperFirst)}
            slidesPerView={1}
            centeredSlides={true}
            autoplay={{
                delay: 6000,
                disableOnInteraction: false,
            }}
            // pagination={{
            // clickable: true,
            // }}
            navigation={false}
            modules={[Autoplay, Pagination, Navigation]}
            className={isTablet ? "mySwiperSliderMB" : "mySwiperSliderMBMobile"}
        >
            {listRespData.map((item, index) => (
                <SwiperSlide key={index}>
                    <div className={ isTablet ? 'secondSubMainContainerSliderMB' : 'secondSubMainContainerSliderMBMobile' }>
                        { isTablet ? (
                            <>
                            <div className='imgAddCardMainViewSliderMB' style={{ backgroundImage: `url(${item.imgLinkCard.desktop})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                {/* <img src={item.imgLinkCard} alt="imagem"  className={ isTablet ? 'imgAddCardSliderMB' : 'imgAddCardSliderMBMobile' } /> */}
                            </div>
                            <div className='txtAddCardMainViewSliderMB'>
                                <div className='txtAddCardMainTwoViewSliderMB'>
                                    <div className='txtAddCardMainTitleViewSliderMB'>
                                        <div className='txtAddCardBoldSliderMB'>{item.titleLinkCard}</div>
                                    </div>
                                    <div className='txtAddCardMainSubTitleViewSliderMB'>
                                        <div className='txtAddCardRegularSliderMB'>{item.txtLinkCard}</div>
                                    </div>
                                </div>
                            </div>
                            </>
                        ) : ( isMobile ? (
                            <>
                            <div className='imgAddCardMainViewSliderMBMobile'>
                                <img src={item.imgLinkCard.tablet} alt="imagem"  className='imgAddCardSliderMBMobile'/>
                            </div>
                            <div className='txtAddCardMainViewSliderMBMobile'>
                                <div className='txtAddCardMainSubTitleViewSliderMB'>
                                    <span className='txtAddCardBoldSliderMBMobile'>{item.titleLinkCard}</span>
                                    <span className='txtAddCardRegularSliderMBMobile'> {item.txtLinkCard}</span>
                                </div>
                            </div>
                            </>
                            ) : ( 
                            <>
                            <div className='imgAddCardMainViewSliderMBMobile'>
                                <img src={item.imgLinkCard.mobile} alt="imagem"  className='imgAddCardSliderMBMobile'/>
                            </div>
                            <div className='txtAddCardMainViewSliderMBMobile'>
                                <div className='txtAddCardMainSubTitleViewSliderMB'>
                                    <span className='txtAddCardBoldSliderMBMobile'>{item.titleLinkCard}</span>
                                    <span className='txtAddCardRegularSliderMBMobile'> {item.txtLinkCard}</span>
                                </div>
                            </div>
                            </>
                        ))}
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>

        <div className={isTablet ? 'thirdSubMainContainerCircleNavSliderMB' : 'thirdSubMainContainerSliderMBMobile'}>
            <button className='iconArrowLeftViewContainerSliderMB' onClick={prevImageFirst} disabled={swiperIndexFirst == 0}>
                <FaArrowLeftLong className='iconArrowSliderMB' />
            </button>

            <div className='cirlceSelectedSliderMB'>
                <div className='circleMainvViewSliderMB'>
                    <div className='circleContainerSliderMB'>
                        <div className={swiperIndexFirst == 0 ? 'circleSelectedViewSliderMB' : 'circleViewSliderMB'} />
                    </div>
                    <div className='circleContainerSliderMB'>
                        <div className={swiperIndexFirst == 1 ? 'circleSelectedViewSliderMB' : 'circleViewSliderMB'} />
                    </div>
                    <div className='circleContainerSliderMB'>
                        <div className={swiperIndexFirst >= 2 ? 'circleSelectedViewSliderMB' : 'circleViewSliderMB'} />
                    </div>
                </div>
            </div>

            <button className='iconArrowRightViewContainerSliderMB' onClick={nextImageFirst} disabled={swiperIndexFirst >= listRespData.length - 1}>
                <FaArrowRightLong className='iconArrowSliderMB' />
            </button>
        </div>

    </div>
  )
}

export default SliderMB;